import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden bg-charcoal-900" data-id="element-23">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1585747860115-18423e3e48f5?auto=format&fit=crop&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-24">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-charcoal-900/80 mix-blend-multiply" data-id="element-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900 via-charcoal-900/40 to-transparent" data-id="element-26" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 flex flex-col items-center text-center max-w-4xl" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-28">
          <img src="https://cdn.magicpatterns.com/uploads/f6oGZNXWeK5xhE3LRPxK4U/1000121817.png" alt="MA Barber Studio" className="w-60 h-60 md:w-80 md:h-80 object-cover rounded-full mb-4 md:mb-6 mx-auto -mt-4 border-0 outline-none ring-0" style={{
          clipPath: 'circle(48% at center)'
        }} data-id="element-29" />
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-serif text-cream leading-tight mb-4 md:mb-6" data-id="element-30">
            No es un simple corte.
            <br data-id="element-31" />
            <span className="italic text-gold-400" data-id="element-32">Es la transformación</span>
            <br data-id="element-33" />
            que tu imagen merece.
          </h1>
        </motion.div>

        <motion.p className="text-base md:text-xl text-cream-muted font-light max-w-2xl mb-6 md:mb-10 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-34">
          Experimenta el arte de la barbería Old School en el corazón de Pavas.
          Recupera tu confianza con un servicio personalizado donde tú eres el
          protagonista, no el reloj.
        </motion.p>

        <motion.a href="https://book.weibook.co/ma-barber-studio" target="_blank" rel="noopener noreferrer" className="inline-block bg-gold-500 hover:bg-gold-400 text-charcoal-900 font-semibold py-4 px-8 rounded-sm transition-all duration-300 transform hover:scale-105 uppercase tracking-wider text-sm shadow-[0_0_20px_rgba(212,175,55,0.2)]" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-35">
          SÍ, QUIERO MI TRANSFORMACIÓN — 10% DTO PRIMERA VISITA
        </motion.a>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 text-gold-500/70 flex flex-col items-center gap-2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} data-id="element-36">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-37">
          <ChevronDown size={20} data-id="element-38" />
        </motion.div>
      </motion.div>
    </section>;
}